/// <reference types="./durations.d.mts" />
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $duration from "../../gleam_time/gleam/time/duration.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import { Ok, makeError, divideFloat } from "../gleam.mjs";

const FILEPATH = "src/app_config/durations.gleam";

export function to_h_or_m(duration) {
  let _block;
  let _pipe = duration;
  let _pipe$1 = ((_capture) => {
    return $timestamp.difference($timestamp.system_time(), _capture);
  })(_pipe);
  _block = $duration.to_seconds(_pipe$1);
  let duration$1 = _block;
  if (duration$1 > 3600.0) {
    let duration$2 = $float.round(divideFloat(duration$1, 3600.0));
    return $int.to_string(duration$2) + " hours";
  } else {
    let duration$2 = $float.round(divideFloat(duration$1, 60.0));
    return $int.to_string(duration$2) + " minutes";
  }
}

function continue_do_to_ydhms(value) {
  return $bool.guard(
    value <= 1.0,
    "",
    () => { return ", " + do_to_ydhms(value); },
  );
}

function do_to_ydhms(duration) {
  if (duration > 31_536_000.0) {
    let years = $float.truncate(divideFloat(duration, 31_536_000.0));
    let $ = $float.modulo(duration, 31_536_000.0);
    if (!($ instanceof Ok)) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "app_config/durations",
        19,
        "do_to_ydhms",
        "Pattern match failed, no pattern matched the value.",
        { value: $, start: 465, end: 523, pattern_start: 476, pattern_end: 484 }
      )
    }
    let days = $[0];
    return ($int.to_string(years) + " years") + continue_do_to_ydhms(days);
  } else {
    if (duration > 86_400.0) {
      let days = $float.truncate(divideFloat(duration, 86_400.0));
      let $ = $float.modulo(duration, 86_400.0);
      if (!($ instanceof Ok)) {
        throw makeError(
          "let_assert",
          FILEPATH,
          "app_config/durations",
          24,
          "do_to_ydhms",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $,
            start: 694,
            end: 751,
            pattern_start: 705,
            pattern_end: 716
          }
        )
      }
      let minutes = $[0];
      return ($int.to_string(days) + " days") + continue_do_to_ydhms(minutes);
    } else {
      if (duration > 3600.0) {
        let hours = $float.truncate(divideFloat(duration, 3600.0));
        let $ = $float.modulo(duration, 3600.0);
        if (!($ instanceof Ok)) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "app_config/durations",
            29,
            "do_to_ydhms",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 920,
              end: 975,
              pattern_start: 931,
              pattern_end: 942
            }
          )
        }
        let minutes = $[0];
        return ($int.to_string(hours) + " hours") + continue_do_to_ydhms(
          minutes,
        );
      } else {
        if (duration > 60.0) {
          let minutes = $float.truncate(divideFloat(duration, 60.0));
          let $ = $float.modulo(duration, 60.0);
          if (!($ instanceof Ok)) {
            throw makeError(
              "let_assert",
              FILEPATH,
              "app_config/durations",
              34,
              "do_to_ydhms",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $,
                start: 1144,
                end: 1197,
                pattern_start: 1155,
                pattern_end: 1166
              }
            )
          }
          let seconds = $[0];
          return ($int.to_string(minutes) + " minutes") + continue_do_to_ydhms(
            seconds,
          );
        } else {
          let seconds = $float.truncate(duration);
          return $int.to_string(seconds) + " seconds";
        }
      }
    }
  }
}

export function to_ydhms(duration) {
  let _pipe = $timestamp.system_time();
  let _pipe$1 = $timestamp.difference(_pipe, duration);
  let _pipe$2 = $duration.to_seconds(_pipe$1);
  return do_to_ydhms(_pipe$2);
}
